import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ChangeUserDetailsRequest } from '@vi-iot/client';

import { UserDetailsStore } from '@store';

@Component({
  selector: 'app-change-user-details-modal',
  templateUrl: './change-user-details-modal.component.html',
  styleUrls: ['./change-user-details-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeUserDetailsModalComponent {
  userRole$ = this.userDetailsStore.getUserRole();
  personal$ = this.userDetailsStore.getUser();
  contact$ = this.userDetailsStore.getUserContact();
  address$ = this.userDetailsStore.getUserAddress();
  isEmailVerified$ = this.userDetailsStore.isEmailVerified();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      changeType: 'personal' | 'address' | 'contact' | 'other';
    },
    public dialogRef: MatDialogRef<ChangeUserDetailsModalComponent>,
    public userDetailsStore: UserDetailsStore
  ) {}

  onSave(body: ChangeUserDetailsRequest): void {
    this.userDetailsStore.changeUserDetails(body);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
